import styled from '@emotion/styled';
import { Box, Button, Grid, Paper, Popper, Slider, withStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export const FilterMenuButton = styled(Button)<{ opened: number; filtered: number }>`
  position: relative;
  background-color: ${({ opened, filtered }) => (filtered ? '#ccedfa' : opened ? '#d7dbdd' : 'transparent')} !important;
  color: ${({ filtered }) => (filtered ? '#00a4e4' : '#555')};

  .MuiButton-startIcon {
    margin-right: 2px;
  }
`;

export const FilterMenuFilterForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FilterMenuRowContainer = styled(Box)`
  display: flex;

  .MuiFormControl-marginDense {
    margin: 0;
  }

  & > *:first-of-type {
    padding-right: 15px;
  }

  & > *:last-child {
    padding-left: 15px;
  }
`;

export const FilterMenuProgressContainer = styled(Box)`
  width: calc(50% - 15px);
  padding: 0 !important;
`;

export const FilterMenuPopper = styled(Popper)`
  z-index: 1200;
`;

export const FilterMenuContainer = styled(Paper)`
  position: relative;
  margin-top: 8px;
  padding: 20px;
  border-radius: 10px;
  min-width: 750px;
  width: 80vw;
  max-width: 860px;
`;

export const GridRow = styled(Grid)`
  margin: -18px 0 !important;
`;

export const InputLabel = styled.div`
  display: flex;
  margin: 10px 0 6px 0;
`;

export const CustomSlider = withStyles({
  root: {
    paddingTop: 26,
  },
  valueLabel: {
    left: 'calc(-50% - 1px)',
    top: '-20px',
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  track: {
    color: '#00a4e4',
  },
  thumb: {
    width: 16,
    height: 16,
    backgroundColor: '#fff',
    border: '1px solid #00a4e4',
    '&:before': {
      content: "''",
      display: 'block',
      width: 4,
      height: 4,
      backgroundColor: '#00a4e4',
      borderRadius: '50%',
    },
  },
})(Slider);

export const ButtonsContainer = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  padding: 0 !important;

  > button {
    margin-left: 15px;
  }
`;

export const Arrow = styled(ArrowDropDownIcon)`
  position: absolute;
  bottom: -27px;
  color: #fff;
  transform: rotate(180deg);
  font-size: 40px !important;
  filter: drop-shadow(0px -2px 2px #536171);
`;
